/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ProcessingPartnerModel } from '../model/processingPartnerModel';
import { ProcessingPartnerModelDto } from '../model/processingPartnerModelDto';
import { SenderIdModelDto } from '../model/senderIdModelDto';
import { SenderIdRequestModel } from '../model/senderIdRequestModel';
import { SenderIdRequestViewModel } from '../model/senderIdRequestViewModel';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SenderIdRequestService {

    protected basePath = 'http://10.1.1.123:30118';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param id 
     * @param creatorId 
     * @param serviceProviderName 
     * @param serviceProviderEmailAddress 
     * @param senderId 
     * @param senderIdType 
     * @param nameOfOrganization 
     * @param serviceProviderCountryOfResidence 
     * @param comments 
     * @param authorizationLetter 
     * @param regCertificate 
     * @param status 
     * @param adminsReasonForDecline 
     * @param dateCreated 
     * @param dateUpdated 
     * @param loginUrl 
     * @param aggregatorId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public senderIdRequestCreateSenderIdRequestRequest(id?: string, creatorId?: string, serviceProviderName?: string, serviceProviderEmailAddress?: string, senderId?: string, senderIdType?: number, nameOfOrganization?: string, serviceProviderCountryOfResidence?: string, comments?: string, authorizationLetter?: Blob, regCertificate?: Blob, status?: number, adminsReasonForDecline?: string, dateCreated?: Date, dateUpdated?: Date, loginUrl?: string, aggregatorId?: string, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public senderIdRequestCreateSenderIdRequestRequest(id?: string, creatorId?: string, serviceProviderName?: string, serviceProviderEmailAddress?: string, senderId?: string, senderIdType?: number, nameOfOrganization?: string, serviceProviderCountryOfResidence?: string, comments?: string, authorizationLetter?: Blob, regCertificate?: Blob, status?: number, adminsReasonForDecline?: string, dateCreated?: Date, dateUpdated?: Date, loginUrl?: string, aggregatorId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public senderIdRequestCreateSenderIdRequestRequest(id?: string, creatorId?: string, serviceProviderName?: string, serviceProviderEmailAddress?: string, senderId?: string, senderIdType?: number, nameOfOrganization?: string, serviceProviderCountryOfResidence?: string, comments?: string, authorizationLetter?: Blob, regCertificate?: Blob, status?: number, adminsReasonForDecline?: string, dateCreated?: Date, dateUpdated?: Date, loginUrl?: string, aggregatorId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public senderIdRequestCreateSenderIdRequestRequest(id?: string, creatorId?: string, serviceProviderName?: string, serviceProviderEmailAddress?: string, senderId?: string, senderIdType?: number, nameOfOrganization?: string, serviceProviderCountryOfResidence?: string, comments?: string, authorizationLetter?: Blob, regCertificate?: Blob, status?: number, adminsReasonForDecline?: string, dateCreated?: Date, dateUpdated?: Date, loginUrl?: string, aggregatorId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


















        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): void | HttpParams; };
        let useForm = false;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (id !== undefined) {
            formParams = formParams.append('Id', <any>id) || formParams;
        }
        if (creatorId !== undefined) {
            formParams = formParams.append('CreatorId', <any>creatorId) || formParams;
        }
        if (serviceProviderName !== undefined) {
            formParams = formParams.append('ServiceProviderName', <any>serviceProviderName) || formParams;
        }
        if (serviceProviderEmailAddress !== undefined) {
            formParams = formParams.append('ServiceProviderEmailAddress', <any>serviceProviderEmailAddress) || formParams;
        }
        if (senderId !== undefined) {
            formParams = formParams.append('SenderId', <any>senderId) || formParams;
        }
        if (senderIdType !== undefined) {
            formParams = formParams.append('SenderIdType', <any>senderIdType) || formParams;
        }
        if (nameOfOrganization !== undefined) {
            formParams = formParams.append('NameOfOrganization', <any>nameOfOrganization) || formParams;
        }
        if (serviceProviderCountryOfResidence !== undefined) {
            formParams = formParams.append('ServiceProviderCountryOfResidence', <any>serviceProviderCountryOfResidence) || formParams;
        }
        if (comments !== undefined) {
            formParams = formParams.append('Comments', <any>comments) || formParams;
        }
        if (authorizationLetter !== undefined) {
            formParams = formParams.append('AuthorizationLetter', <any>authorizationLetter) || formParams;
        }
        if (regCertificate !== undefined) {
            formParams = formParams.append('RegCertificate', <any>regCertificate) || formParams;
        }
        if (status !== undefined) {
            formParams = formParams.append('Status', <any>status) || formParams;
        }
        if (adminsReasonForDecline !== undefined) {
            formParams = formParams.append('AdminsReasonForDecline', <any>adminsReasonForDecline) || formParams;
        }
        if (dateCreated !== undefined) {
            formParams = formParams.append('DateCreated', <any>dateCreated) || formParams;
        }
        if (dateUpdated !== undefined) {
            formParams = formParams.append('DateUpdated', <any>dateUpdated) || formParams;
        }
        if (loginUrl !== undefined) {
            formParams = formParams.append('LoginUrl', <any>loginUrl) || formParams;
        }
        if (aggregatorId !== undefined) {
            formParams = formParams.append('AggregatorId', <any>aggregatorId) || formParams;
        }

        return this.httpClient.post<string>(`${this.basePath}/api/SenderIdRequest/CreateSenderIdRequestRequest`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public senderIdRequestDeleteProcessingPartnerRecord(id?: string, observe?: 'body', reportProgress?: boolean): Observable<ProcessingPartnerModel>;
    public senderIdRequestDeleteProcessingPartnerRecord(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProcessingPartnerModel>>;
    public senderIdRequestDeleteProcessingPartnerRecord(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProcessingPartnerModel>>;
    public senderIdRequestDeleteProcessingPartnerRecord(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<ProcessingPartnerModel>(`${this.basePath}/api/SenderIdRequest/DeleteProcessingPartnerRecord`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public senderIdRequestDeleteSenderIdProcessRequest(id?: string, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public senderIdRequestDeleteSenderIdProcessRequest(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public senderIdRequestDeleteSenderIdProcessRequest(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public senderIdRequestDeleteSenderIdProcessRequest(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<boolean>(`${this.basePath}/api/SenderIdRequest/DeleteSenderIdProcessRequest`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public senderIdRequestGetAllProcessingPartner(observe?: 'body', reportProgress?: boolean): Observable<Array<ProcessingPartnerModel>>;
    public senderIdRequestGetAllProcessingPartner(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ProcessingPartnerModel>>>;
    public senderIdRequestGetAllProcessingPartner(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ProcessingPartnerModel>>>;
    public senderIdRequestGetAllProcessingPartner(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<ProcessingPartnerModel>>(`${this.basePath}/api/SenderIdRequest/GetAllProcessingPartner`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param searchWord 
     * @param skip 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public senderIdRequestGetAllProcessingPartnerWithSearchSkipAndTake(searchWord?: string, skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<ProcessingPartnerModelDto>;
    public senderIdRequestGetAllProcessingPartnerWithSearchSkipAndTake(searchWord?: string, skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProcessingPartnerModelDto>>;
    public senderIdRequestGetAllProcessingPartnerWithSearchSkipAndTake(searchWord?: string, skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProcessingPartnerModelDto>>;
    public senderIdRequestGetAllProcessingPartnerWithSearchSkipAndTake(searchWord?: string, skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (searchWord !== undefined && searchWord !== null) {
            queryParameters = queryParameters.set('searchWord', <any>searchWord);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ProcessingPartnerModelDto>(`${this.basePath}/api/SenderIdRequest/GetAllProcessingPartnerWithSearchSkipAndTake`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public senderIdRequestGetAllSenderIdProcessRequest(observe?: 'body', reportProgress?: boolean): Observable<Array<SenderIdRequestModel>>;
    public senderIdRequestGetAllSenderIdProcessRequest(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SenderIdRequestModel>>>;
    public senderIdRequestGetAllSenderIdProcessRequest(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SenderIdRequestModel>>>;
    public senderIdRequestGetAllSenderIdProcessRequest(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<SenderIdRequestModel>>(`${this.basePath}/api/SenderIdRequest/GetAllSenderIdProcessRequest`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param creatorId 
     * @param searchWord 
     * @param skip 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public senderIdRequestGetAllSenderIdProcessRequestWithPagination(creatorId?: string, searchWord?: string, skip?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<SenderIdModelDto>;
    public senderIdRequestGetAllSenderIdProcessRequestWithPagination(creatorId?: string, searchWord?: string, skip?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SenderIdModelDto>>;
    public senderIdRequestGetAllSenderIdProcessRequestWithPagination(creatorId?: string, searchWord?: string, skip?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SenderIdModelDto>>;
    public senderIdRequestGetAllSenderIdProcessRequestWithPagination(creatorId?: string, searchWord?: string, skip?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (creatorId !== undefined && creatorId !== null) {
            queryParameters = queryParameters.set('creatorId', <any>creatorId);
        }
        if (searchWord !== undefined && searchWord !== null) {
            queryParameters = queryParameters.set('searchWord', <any>searchWord);
        }
        if (skip !== undefined && skip !== null) {
            queryParameters = queryParameters.set('skip', <any>skip);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SenderIdModelDto>(`${this.basePath}/api/SenderIdRequest/GetAllSenderIdProcessRequestWithPagination`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public senderIdRequestGetDefaultProcessingPartner(observe?: 'body', reportProgress?: boolean): Observable<ProcessingPartnerModel>;
    public senderIdRequestGetDefaultProcessingPartner(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProcessingPartnerModel>>;
    public senderIdRequestGetDefaultProcessingPartner(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProcessingPartnerModel>>;
    public senderIdRequestGetDefaultProcessingPartner(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ProcessingPartnerModel>(`${this.basePath}/api/SenderIdRequest/GetDefaultProcessingPartner`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public senderIdRequestGetProcessingPartnerRecord(id?: string, observe?: 'body', reportProgress?: boolean): Observable<ProcessingPartnerModel>;
    public senderIdRequestGetProcessingPartnerRecord(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ProcessingPartnerModel>>;
    public senderIdRequestGetProcessingPartnerRecord(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ProcessingPartnerModel>>;
    public senderIdRequestGetProcessingPartnerRecord(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ProcessingPartnerModel>(`${this.basePath}/api/SenderIdRequest/GetProcessingPartnerRecord`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public senderIdRequestGetSenderIdProcessRequestById(id?: string, observe?: 'body', reportProgress?: boolean): Observable<SenderIdRequestModel>;
    public senderIdRequestGetSenderIdProcessRequestById(id?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SenderIdRequestModel>>;
    public senderIdRequestGetSenderIdProcessRequestById(id?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SenderIdRequestModel>>;
    public senderIdRequestGetSenderIdProcessRequestById(id?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SenderIdRequestModel>(`${this.basePath}/api/SenderIdRequest/GetSenderIdProcessRequestById`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public senderIdRequestInsertProcessingPartnerRecord(model: ProcessingPartnerModel, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public senderIdRequestInsertProcessingPartnerRecord(model: ProcessingPartnerModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public senderIdRequestInsertProcessingPartnerRecord(model: ProcessingPartnerModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public senderIdRequestInsertProcessingPartnerRecord(model: ProcessingPartnerModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling senderIdRequestInsertProcessingPartnerRecord.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<boolean>(`${this.basePath}/api/SenderIdRequest/InsertProcessingPartnerRecord`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public senderIdRequestUpdateProcessingPartnerRecord(model: ProcessingPartnerModel, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public senderIdRequestUpdateProcessingPartnerRecord(model: ProcessingPartnerModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public senderIdRequestUpdateProcessingPartnerRecord(model: ProcessingPartnerModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public senderIdRequestUpdateProcessingPartnerRecord(model: ProcessingPartnerModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling senderIdRequestUpdateProcessingPartnerRecord.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<boolean>(`${this.basePath}/api/SenderIdRequest/UpdateProcessingPartnerRecord`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public senderIdRequestUpdateProcessingPartnerStatus(model: ProcessingPartnerModel, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public senderIdRequestUpdateProcessingPartnerStatus(model: ProcessingPartnerModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public senderIdRequestUpdateProcessingPartnerStatus(model: ProcessingPartnerModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public senderIdRequestUpdateProcessingPartnerStatus(model: ProcessingPartnerModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling senderIdRequestUpdateProcessingPartnerStatus.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<boolean>(`${this.basePath}/api/SenderIdRequest/UpdateProcessingPartnerStatus`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public senderIdRequestUpdateSenderIdRequestRequest(model: SenderIdRequestViewModel, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public senderIdRequestUpdateSenderIdRequestRequest(model: SenderIdRequestViewModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public senderIdRequestUpdateSenderIdRequestRequest(model: SenderIdRequestViewModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public senderIdRequestUpdateSenderIdRequestRequest(model: SenderIdRequestViewModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling senderIdRequestUpdateSenderIdRequestRequest.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<string>(`${this.basePath}/api/SenderIdRequest/UpdateSenderIdRequestRequest`,
            model,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
